import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTagModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryCGIModule } from '../promptuary-cgi/promptuary-cgi.module';
import { PromptuaryReasonsModule } from '../promptuary-reasons/promptuary-reasons.module';
import { PromptuaryView } from './promptuary-view.component';

@NgModule({
	declarations: [PromptuaryView],
	imports: [
		CommonModule,
		PromptuaryCGIModule,
		TranslateModule.forChild(),
		PromptuaryReasonsModule,
		SharedModule,
		FreudTagModule,
	],
	exports: [PromptuaryView],
	providers: [],
})
export class PromptuaryViewModule {}
